<template>
  <fieldset class="toggle-group-wrapper">
    <legend v-if="label" class="toggle-group-label">{{ label }}</legend>
    <div class="toggle-group">
      <button
        v-for="option in options"
        :key="option.value"
        :class="['toggle-option', {
          'active': modelValue === option.value,
          'null-state': modelValue === null && allowNull
        }]"
        type="button"
        @click="handleClick(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </fieldset>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: null
  },
  modelValue: {
    type: [Boolean, null],
    default: null
  },
  options: {
    type: Array,
    required: true,
    validator: (options) => {
      return options.every(opt =>
        opt &&
        typeof opt.label === 'string' &&
        (opt.value === true || opt.value === false || opt.value === null)
      )
    }
  },
  allowNull: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue'])

function handleClick (value) {
  // Hvis allowNull og brukeren klikker på aktiv knapp, sett til null
  if (props.allowNull && props.modelValue === value) {
    emit('update:modelValue', null)
  } else {
    emit('update:modelValue', value)
  }
}
</script>

<style scoped>
.toggle-group-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: none;
  padding: 0;
  margin: 0;
}

.toggle-group-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text);
  margin-bottom: 0.25rem;
  padding: 0;
}

.toggle-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.toggle-option {
  flex: 1;
  min-width: 120px;
  padding: 0.5rem 1rem;
  border: 2px solid var(--color-border);
  background-color: var(--color-background);
  color: var(--color-text);
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  text-align: center;
}

.toggle-option:hover {
  border-color: var(--color-primary);
  background-color: var(--color-background-hover);
}

.toggle-option.active {
  background-color: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
  font-weight: 600;
}

.toggle-option.active:hover {
  background-color: var(--color-primary-dark, var(--color-primary));
  border-color: var(--color-primary-dark, var(--color-primary));
}

.toggle-option.null-state {
  border-color: var(--color-border);
  background-color: var(--color-background);
  color: var(--color-text-muted);
}

.toggle-option.null-state:hover {
  border-color: var(--color-primary);
  background-color: var(--color-background-hover);
  color: var(--color-text);
}
</style>

